import { WarningTwoIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  HStack,
  Icon,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import { api } from 'api/api';
import { AccountContext } from 'components/AccountContext';
import SelectField from 'components/SelectField';
import { Formik } from 'formik';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const onlyNumbers = (str) => str.replace(/[^0-9]/g, '');

function DesistenciaModal({ state, agenda, setPausedFetchRdy }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isOpenPosDesistencia, onOpen: openPosDesistencia, onClose: closePosDesistencia } = useDisclosure();
  const [checkingFaturado, setCheckingFaturado] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const navigate = useNavigate();
  const [tipoDesistencia, setTipoDesistencia] = useState('credito');
  const { user, setPage } = useContext(AccountContext);
  const [isFaturado, setIsFaturado] = useState(!user?.allowsTelemedicina?.paga_telemedicina);
  const [motivosDesistencia, setMotivosDesistencia] = useState([]);
  const [motivoEscolhido, setMotivoEscolhido] = useState(null);
  const [outroTexto, setOutroTexto] = useState('');
  const [cancelamento_id, setCancelamentoId] = useState(null);
  const [disabledCancelamento, setDisabledCancelamento] = useState(true);

  const desistirAtendimento = useCallback(async () => {
    setPausedFetchRdy(false);
    setIsLoading(false);
    setError(null);

    try {
      const response = await api(
        ENDPOINT +
          `/schedule/updateTelemedAtendimento/${agenda}/${onlyNumbers(state.patient)}/${cancelamento_id}/${
            outroTexto ? encodeURIComponent(outroTexto) : null
          }/${user?.credito_id}`,
        {
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'GET',
        },
      );
      const postsData = await response.json();
      navigate('/dashboard', { replace: true });
    } catch (error) {
      console.log(error);
      setError('Ocorreu um erro durante a solicitação de desistência');
    } finally {
      setPausedFetchRdy(false);
      setIsLoading(false);
    }
  }, [agenda, navigate, setPausedFetchRdy, state.patient, cancelamento_id, outroTexto]);

  const desistirAtendimentoCredito = useCallback(async () => {
    setPausedFetchRdy(true);
    setIsLoading(true);
    setError(null);
    try {
      const response = await api(
        ENDPOINT +
          `/schedule/updateTelemedAtendimento/${agenda}/${onlyNumbers(state.patient)}/${cancelamento_id}/${
            outroTexto ? encodeURIComponent(outroTexto) : null
          }/${user?.credito_id}`,
        {
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'GET',
        },
      );
      const postsData = await response.json();

      setTipoDesistencia('credito');
      onClose();
      openPosDesistencia();
    } catch (error) {
      console.log(error);
      setError('Ocorreu um erro durante a solicitação de desistência');
    } finally {
      setIsLoading(false);
    }
  }, [agenda, onClose, openPosDesistencia, setPausedFetchRdy, state.patient, cancelamento_id, outroTexto]);

  const desistirAtendimentoReembolso = useCallback(async () => {
    setPausedFetchRdy(true);
    setIsLoading(true);
    setError(null);
    try {
      const response = await api(
        ENDPOINT +
          `/schedule/updateTelemedAtendimento/${agenda}/${onlyNumbers(state.patient)}/${cancelamento_id}/${
            outroTexto ? encodeURIComponent(outroTexto) : null
          }/${user?.credito_id}?reembolso=true`,
        {
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'GET',
        },
      );
      const postsData = await response.json();

      setTipoDesistencia('reembolso');
      onClose();
      openPosDesistencia();
    } catch (error) {
      console.log(error);
      setError('Ocorreu um erro durante a solicitação de desistência');
    } finally {
      setIsLoading(false);
    }
  }, [agenda, onClose, openPosDesistencia, setPausedFetchRdy, state.patient, cancelamento_id, outroTexto]);

  const verificarFaturado = useCallback(async () => {
    setPausedFetchRdy(true);
    setCheckingFaturado(true);
    setError(null);
    try {
      const response = await api(ENDPOINT + `/schedule/verifica-faturado/${agenda}`, {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      });
      const data = await response.json();
      setIsFaturado(data.faturado);
    } catch (error) {
      console.log(error);
      setError('Ocorreu um erro durante a verificação de pagamento');
    } finally {
      setPausedFetchRdy(false);
      setCheckingFaturado(false);
    }
  }, [agenda, setPausedFetchRdy]);

  async function fetchMotivosDesistencia() {
    try {
      const postsData = await api(`${ENDPOINT}/clients/fetchMotivosDesistencia`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });
      const response = await postsData.json();
      if (response !== null || response !== undefined) {
        setMotivosDesistencia(response);
      }
    } catch (error) {
      console.log(error);
      setError('Houve um problema ao buscar pelos motivos de desistência');
    }
  }

  useEffect(() => {
    fetchMotivosDesistencia();
  }, []);

  const SelectClient = () => {
    const optionsData = motivosDesistencia.map((m) => ({
      id: m.cancelamento_id,
      descricao: m.descricao,
    }));

    const arrayMotivosDesistencia = optionsData.map((m) => m.descricao);

    return (
      <SelectField
        name="motivos"
        background="#F3F3F3"
        color="#585858"
        placeholder="Selecione o motivo"
        variant="outline"
        textAlign="left"
        borderColor="gray.300"
        w="100%"
        borderRadius="10px"
        fontWeight="bold"
        options={arrayMotivosDesistencia}
        onChange={(index) => {
          if (index >= 0) {
            const motivoSelecionado = optionsData[index];
            setMotivoEscolhido(motivoSelecionado);
            setCancelamentoId(motivoSelecionado.id);
          }
        }}
      />
    );
  };

  useEffect(() => {
    if (motivoEscolhido == null) {
      setDisabledCancelamento(true);
      return;
    }

    if (motivoEscolhido?.descricao !== 'Outro') {
      setOutroTexto(null);
    }

    if (motivoEscolhido?.descricao == 'Outro' && outroTexto === '') {
      setDisabledCancelamento(true);
      return;
    }

    setMotivoEscolhido(motivoEscolhido);
    setDisabledCancelamento(false);
    setOutroTexto(outroTexto);

    console.log({ motivoEscolhido, outroTexto });
  }, [motivoEscolhido, outroTexto]);

  return (
    <>
      <Button
        isFullWidth
        size="sm"
        colorScheme="gray"
        variant="outline"
        color="#585858"
        mt={4}
        isLoading={checkingFaturado}
        onClick={async () => {
          await verificarFaturado();
          onOpen();
        }}
      >
        Desistir do atendimento
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="xs" isCentered>
        <ModalOverlay />
        <ModalContent textAlign={'center'} borderRadius={20} m={8}>
          <ModalHeader fontSize={'md'}>Você tem certeza disso?</ModalHeader>
          <ModalBody fontSize={'xs'}>
            <Text fontSize={'sm'} color={'#585858'}>
              Se desistir do atendimento, você perderá sua posição na fila.
            </Text>
          </ModalBody>

          <ModalFooter>
            <Formik initialValues={{ clients: 0 }} validateOnChange={false} validateOnBlur={false}>
              <VStack w={'100%'}>
                {error && (
                  <Text fontSize={'sm'} fontWeight={'bold'} bgColor={'#CB0000'} color={'white'} p={2} rounded={10}>
                    {error}
                  </Text>
                )}

                {!user.pronto_gratis && (
                  <Box
                    borderRadius="0.8em"
                    p={4}
                    w="100%"
                    border="1px solid #FFCBCF"
                    bg="linear-gradient(90deg, #FFEAED 0%, #FFEAED 100%)"
                    boxShadow="0 0 5px rgba(255, 203, 207, 0.5)"
                  >
                    <VStack align="flex-start" spacing={1}>
                      <HStack spacing={2}>
                        <WarningTwoIcon color="#D62422" boxSize={4} />
                        <Text fontWeight="bold" fontSize="0.9em" color="#D62422">
                          Importante!
                        </Text>
                      </HStack>

                      <Text textAlign={'left'} color="#D62422" fontSize="0.8em">
                        Se você faltar, a consulta <b>não poderá ser reagendada</b>. Para marcar outra, <b>será necessário um novo pagamento</b>.
                      </Text>
                    </VStack>
                  </Box>
                )}
                <Text color={'#585858'} fontSize={'sm'} textAlign={'left'} w={'100%'}>
                  Nos informe o motivo da sua desistência
                </Text>
                <SelectClient />

                {motivoEscolhido?.descricao == 'Outro' && (
                  <Textarea
                    placeholder="Digite seu motivo aqui..."
                    value={outroTexto}
                    onChange={(e) => setOutroTexto(e.target.value)}
                    resize="none"
                    borderRadius="lg"
                    borderColor="gray.300"
                    _hover={{ borderColor: 'gray.400' }}
                    _focus={{
                      borderColor: 'blue.400',
                      boxShadow: '0 0 0 1px #4299E1',
                    }}
                    fontSize="md"
                    p={3}
                  />
                )}

                <Button
                  size="sm"
                  colorScheme="teal"
                  onClick={() => {
                    desistirAtendimento();
                  }}
                  isFullWidth
                  isLoading={isLoading}
                  isDisabled={disabledCancelamento}
                >
                  Confirmar desistência
                </Button>

                <Button size="sm" disabled={isLoading} colorScheme="gray" onClick={onClose} variant="ghost" isFullWidth>
                  Cancelar
                </Button>
              </VStack>
            </Formik>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenPosDesistencia} onClose={closePosDesistencia} size="xs" isCentered>
        <ModalOverlay />
        <ModalContent textAlign={'center'} borderRadius={20} m={8}>
          <ModalHeader fontSize={'md'}>Recebemos sua solicitação</ModalHeader>
          <ModalBody fontSize={'sm'}>
            {tipoDesistencia === 'credito' && 'O crédito ficará disponível para a sua próxima consulta'}
            {tipoDesistencia === 'reembolso' &&
              'Para solicitar o reembolso, por favor, entre em contato com nossa central de atendimento pelo número 0800 280-2133 (Whatsapp)'}
          </ModalBody>

          <ModalFooter>
            <VStack w={'100%'}>
              {error && (
                <Text fontSize={'sm'} fontWeight={'bold'} bgColor={'#CB0000'} color={'white'} p={2} rounded={10}>
                  {error}
                </Text>
              )}

              <Button
                size="sm"
                colorScheme="teal"
                onClick={() => {
                  navigate('/dashboard', { replace: true });
                }}
                isFullWidth
                isLoading={isLoading}
              >
                Entendi
              </Button>
            </VStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default DesistenciaModal;
